import { browser } from "$app/environment";
import { APP_DOMAIN, SUBSCRIPTION_SERVICE_URL } from "./Env.js";

export type RequestMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

const REQUEST_TIMEOUT_MS = 10_000;

type Options = {
  useCsrf: boolean;
};

/**
 * Trigger request with proper CSRF token
 */
export const csrfRequest = async (
  url: string,
  method: RequestMethod,
  body?: object | null,
  { useCsrf }: Options = { useCsrf: true }
): Promise<any> => {
  url = SUBSCRIPTION_SERVICE_URL + url;

  const reqParams: RequestInit = {
    method,
  };

  // Set Origin during build and on dev server
  if (!browser) {
    reqParams.headers = {
      Origin: `https://account.${APP_DOMAIN}`,
    };
  }

  if (useCsrf) {
    const response = await fetch(url, {
      method: "OPTIONS",
      credentials: "include",
      signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS),
    });

    const csrfToken = response.headers.get("x-csrf-token");
    if (!csrfToken) {
      throw new Error(`Missing CSRF token on ${url} request`);
    }

    reqParams.headers = {
      ...reqParams.headers,
      "x-csrf-token": csrfToken,
    };
    reqParams.credentials = "include";
  }

  if (body) {
    reqParams.headers = {
      ...reqParams.headers,
      "Content-Type": "application/json",
    };
    reqParams.body = JSON.stringify(body);
  }

  // Extra work necessary to handle throwing in error in case of 403 or 404
  return new Promise((resolve, reject) => {
    fetch(url, { ...reqParams, signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS) })
      .then(async (res) => {
        const resBody = await res.json();
        const successCodes = [200, 201];
        const { status, statusText } = res;
        if (!successCodes.includes(status)) {
          const { errorCode } = resBody;
          const err = {
            status,
            statusText,
            errorCode,
            message: resBody.message,
            url,
          };
          reject(err);
        } else {
          resolve(resBody);
        }
      })
      .catch(reject);
  });
};
